






import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'App'
})
export default class extends Vue {
  mounted() {
    (document.querySelector('.loading-container') as any).style.display = 'none'
  }
}
